import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import Wrapper from "../../components/wrapper";

/**
 *  Interior360Item
 */
class Interior360Item extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    iconSrc: PropTypes.string,
    pcInteriorName: PropTypes.string,
    mbInteriorName: PropTypes.string,
    categories: PropTypes.string,
    interiorViewImageSrc: PropTypes.string,
    interiorViewName: PropTypes.string,
    subInteriorViewImageSrc: PropTypes.string,
    subInteriorViewName: PropTypes.string,
    photoInfo: PropTypes.arrayOf(PropTypes.node),
    index: PropTypes.number,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    onClick: PropTypes.func,
    isCurrent: PropTypes.bool,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    iconSrc: null,
    pcInteriorName: null,
    mbInteriorName: null,
    categories: null,
    interiorViewImageSrc: null,
    interiorViewName: null,
    subInteriorViewImageSrc: null,
    subInteriorViewName: null,
    photoInfo: null,
    index: null,
    onMouseOver: null,
    onMouseOut: null,
    onClick: null,
    isCurrent: false,
  };

  constructor(props) {
    super();
    this.props = props;
  }

  render() {
    const {
      containerId,
      containerClass,
      iconSrc,
      pcInteriorName,
      index,
      onMouseOver,
      onMouseOut,
      onClick,
      isCurrent,
    } = this.props;

    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div className="Interior360Item">
          <a className={'Interior360Item__link' + ((isCurrent) ? ' current' : '')} href="javascript:void(0)"
            onMouseOver={(e)=> {
              e.preventDefault();
              onMouseOver(index);
            }}
            onMouseOut={(e)=> {
              e.preventDefault();
              onMouseOut(index);
            }}
            onClick={(e)=> {
              e.preventDefault();
              onClick(index);
            }}
            style={{backgroundImage: 'url(' + iconSrc + ')'}}>
            <span className="Interior360Item__box">{pcInteriorName}</span>
            <span className="Interior360Item__border">&nbsp;</span>
          </a>
        </div>
      </Wrapper>
    )
  }

}

export default Interior360Item;



// WEBPACK FOOTER //
// ./src/containers/interior360-item/index.jsx